import request from '@/utils/request';
import { getWelcomePackChallenge, signRewardClaimMessage } from '@/api/welcome-pack';
import { generateBotProof } from '@/utils/botDetector';

/**
 * 领取体验金 POST /liyuan-trade/wallet/trial/claim（须钱包 / Privy personal_sign + botProof）
 * @param {{ amount: number|string, event?: Event }} body
 * @returns {Promise<{ txHash?: string, balance: number|string, mintStatus?: 'pending'|'confirmed' }>}
 */
export async function claimTrialFund(body) {
  const amount = body?.amount;
  const challenge = await getWelcomePackChallenge({
    purpose: 'TRIAL',
    amount,
  });
  const signed = await signRewardClaimMessage(challenge?.message, challenge?.address);
  let botProof = '';
  try {
    botProof = await generateBotProof('trial_claim', body?.event);
  } catch (err) {
    console.warn('[trial-fund] generateBotProof error', err);
  }
  return request.post(
    '/liyuan-trade/wallet/trial/claim',
    {
      amount,
      address: signed.address,
      message: signed.message,
      signature: signed.signature,
      botProof,
    },
    {
      timeout: 45000,
    }
  );
}

/**
 * 查询兑换/提现达标条件 GET /liyuan-trade/wallet/trial/withdraw-conditions
 * @param {{ currentWithdrawAmount?: number|string }} [params]
 * @returns {Promise<TrialConditionsVo>}
 */
export function getTrialWithdrawConditions(params = {}) {
  const query = {};
  if (params.currentWithdrawAmount != null && params.currentWithdrawAmount !== '') {
    query.currentWithdrawAmount = String(params.currentWithdrawAmount);
  }
  return request.get('/liyuan-trade/wallet/trial/withdraw-conditions', query);
}
